import {Component} from '@angular/core';

import { ConfigService } from '../service/config.service';
@Component({
    selector: 'app-investor-relations',
    templateUrl: './investor-relations.component.html',
    styleUrls: ['./investor-relations.component.scss']
})
export class InvestorRelationsComponent {
    constructor(private configService : ConfigService) {}

    getPolicyFileUrlByName(fileName) : string{
        return this.configService.getPolicyFileUrlByName(fileName);
    }
}
